export const EMAIL = "yourlingomap@gmail.com";

// Public booking pages (Calendly), embedded in the booking popup.
// Create two separate Calendly event types and paste each link here.
// Until a dedicated "kids" event exists, it reuses the same link as adults.
export const BOOKING_URLS = {
  adults: "https://calendly.com/yourlingomap/30min",
  kids: "https://calendly.com/yourlingomap/30min",
};

export const mailto = (subject, body = "") =>
  `mailto:${EMAIL}?subject=${encodeURIComponent(subject)}${
    body ? `&body=${encodeURIComponent(body)}` : ""
  }`;

export const content = {
  ja: {
    langLabel: "JA",
    nav: {
      method: "メソッド",
      consulting: "子育て相談",
      about: "Lucaについて",
      book: "無料相談を予約",
    },
    hero: {
      eyebrow: "MY LINGO MAP",
      tagline: "YOUR PATH TO LEARNING HOW TO LEARN A FOREIGN LANGUAGE",
      titleLines: ["外国語学習は", "「才能」ではなく", "「方法」。"],
      body: "年齢も、時間の無さも、才能も、壁ではありません。あなたに合った学び方を見つけ、習慣に変えれば、大人も子どもも「使える」ようになります。",
      ctaBook: "無料相談を予約",
      ctaMethod: "メソッドを見る",
    },
    method: {
      eyebrow: "THE METHOD",
      title: "学びを地図にする 5 つの原則",
      subtitle: "「正しく勉強する」より「実際に使える」ことを大切に。",
      chapters: [
        {
          n: "01",
          jp: "才能ではなく方法",
          en: "A method, not a talent",
          desc: "語学は生まれ持った才能ではありません。正しい方法と考え方があれば、誰でも身につけられます。",
        },
        {
          n: "02",
          jp: "言語は「習慣」",
          en: "Language is a habit",
          desc: "知っていることより「慣れていること」。スマホの使い方を覚えるように、繰り返し触れることで自然に使えるようになります。",
        },
        {
          n: "03",
          jp: "学び方は人それぞれ",
          en: "Everyone learns differently",
          desc: "視覚・聴覚・体感——「入り口」は人によって違います。自分に合うスタイルを知ることが最短ルートです。",
        },
        {
          n: "04",
          jp: "1分間学習法",
          en: "The 1-minute method",
          desc: "YouTube 動画の最初の1分に集中。聞く → 意味を確認 → 発音する。忙しくても続けられる小さな習慣。",
        },
        {
          n: "05",
          jp: "上達は一直線ではない",
          en: "Progress isn't linear",
          desc: "停滞期(プラトー)は成長の準備期間。「あ、わかった!」の瞬間は突然やってきます。",
        },
      ],
    },
    consulting: {
      eyebrow: "FOR FAMILIES · 0–8",
      title: "0〜8歳のための多言語子育て相談",
      lead: "お子さまが2つ以上の言語を自然に身につけられるように。ご家庭に合わせた戦略プランを一緒に設計します。",
      body: "この時期の脳は、言語を吸収する自然な仕組みを持っています。大切なのは「正しい環境」をつくること。ご家庭の状況・目標・言語のバランスをうかがい、無理なく続けられる多言語環境をオーダーメイドで設計します。",
      bullets: [
        "ご家庭に合わせた、パーソナライズされた戦略プラン",
        "2言語以上を育てるための日常環境デザイン",
        "年齢・生活リズムに合わせた無理のない習慣づくり",
        "絵本・動画・遊びを活かしたインプットの設計",
      ],
      cta: "子育て相談を予約",
    },
    about: {
      eyebrow: "MEET YOUR GUIDE",
      title: "こんにちは、Luca です。",
      body: "1997年から語学教育に携わり、3つの国で実践してきました。これまでに約3,000人の学習者をサポート。「正しく勉強する」ことよりも「実際に使える」ことを大切にしています。大人も、適切な方法と心構えがあれば必ず学べます。",
      stats: [
        { value: "1997", label: "から指導" },
        { value: "3", label: "つの国で実践" },
        { value: "3,000", label: "人以上をサポート" },
      ],
    },
    marquee: ["METHOD, NOT TALENT", "習慣が言語をつくる", "YOUR PATH", "多言語子育て", "1分間学習法", "使える語学", "0–8歳", "ADULTS & KIDS"],
    booking: {
      titleAdults: "大人向け 無料相談の予約",
      titleKids: "お子さま(0–8歳)相談の予約",
      desc: "カレンダーからご希望の日時を選んでください。",
      notConfigured: "オンライン予約カレンダーは現在準備中です。下のボタンからメールでご予約いただけます。",
      emailButton: "メールで予約する",
      close: "閉じる",
    },
    testimonials: {
      eyebrow: "VOICES",
      title: "受講生と保護者の声",
      note: "※ 以下は実例に基づくサンプルです。実際のお客様の声に差し替えてください。",
      items: [
        {
          quote: "「才能がない」と諦めていましたが、1分間学習法のおかげで毎日続けられました。3ヶ月で会議の英語が聞き取れるように。",
          name: "M・K さん",
          role: "英語学習者・会社員",
        },
        {
          quote: "5歳の娘の多言語子育てに悩んでいました。我が家に合った戦略プランを一緒に作ってもらい、無理なく2言語の環境が整いました。",
          name: "A・T さん",
          role: "5歳のお子さまの保護者",
        },
        {
          quote: "停滞期に何度も心が折れそうになりましたが、「上達は一直線ではない」という言葉に救われました。今は自然に話せます。",
          name: "R・S さん",
          role: "フランス語学習者",
        },
      ],
    },
    cta: {
      eyebrow: "LET'S TALK",
      title: "無料の「知り合う」相談を予約",
      body: "大人の学習者も、多言語で育てたいお子さまのご家庭も。まずは気軽にお話ししましょう。",
      adults: "大人向けの相談を予約",
      kids: "子ども向け(0–8歳)の相談を予約",
      adultsSubject: "【My Lingo Map】大人向け 無料相談の予約希望",
      kidsSubject: "【My Lingo Map】子ども向け(0–8歳)多言語子育て相談の予約希望",
      mailBody: "お名前:\nご希望の日時:\nご相談内容:\n",
    },
    footer: {
      tagline: "YOUR PATH TO LEARNING HOW TO LEARN A FOREIGN LANGUAGE",
      rights: "© 2026 My Lingo Map. All rights reserved.",
    },
  },
  en: {
    langLabel: "EN",
    nav: {
      method: "Method",
      consulting: "Family Consulting",
      about: "About Luca",
      book: "Book a free call",
    },
    hero: {
      eyebrow: "MY LINGO MAP",
      tagline: "YOUR PATH TO LEARNING HOW TO LEARN A FOREIGN LANGUAGE",
      titleLines: ["Learning a language", "is a method,", "not a talent."],
      body: "Age, lack of time, and \"talent\" are not walls. Find the way of learning that fits you, turn it into a habit, and both adults and children can actually use the language.",
      ctaBook: "Book a free call",
      ctaMethod: "Explore the method",
    },
    method: {
      eyebrow: "THE METHOD",
      title: "5 principles that turn learning into a map",
      subtitle: "We care about being able to use it — not just studying correctly.",
      chapters: [
        {
          n: "01",
          jp: "A method, not a talent",
          en: "才能ではなく方法",
          desc: "Language is not an innate gift. With the right method and mindset, anyone can learn it.",
        },
        {
          n: "02",
          jp: "Language is a habit",
          en: "言語は「習慣」",
          desc: "It's more about being used to it than knowing it. Like learning a new phone, repeated exposure makes it natural.",
        },
        {
          n: "03",
          jp: "Everyone learns differently",
          en: "学び方は人それぞれ",
          desc: "Visual, auditory, kinesthetic — the way in differs per person. Knowing your style is the shortest route.",
        },
        {
          n: "04",
          jp: "The 1-minute method",
          en: "1分間学習法",
          desc: "Focus on the first minute of a YouTube video: listen → check the meaning → say it out loud. A tiny habit anyone can keep.",
        },
        {
          n: "05",
          jp: "Progress isn't linear",
          en: "上達は一直線ではない",
          desc: "Plateaus are preparation time for growth. The \"ah, I got it!\" moment arrives suddenly.",
        },
      ],
    },
    consulting: {
      eyebrow: "FOR FAMILIES · 0–8",
      title: "Multilingual parenting consulting for ages 0–8",
      lead: "So your child can naturally acquire two or more languages. Together we design a strategic plan tailored to your family.",
      body: "At this age, the brain has a natural mechanism for absorbing language. What matters most is creating the right environment. We listen to your situation, goals and language balance, then design a custom multilingual environment you can sustain — without pressure.",
      bullets: [
        "A personalized strategic plan tailored to your family",
        "Everyday environment design to raise 2+ languages",
        "Sustainable habits matched to age and daily rhythm",
        "Input designed around books, video and play",
      ],
      cta: "Book a family consultation",
    },
    about: {
      eyebrow: "MEET YOUR GUIDE",
      title: "Hello, I'm Luca.",
      body: "I've worked in language education since 1997, practicing across three countries and supporting around 3,000 learners. I care more about \"actually being able to use\" a language than \"studying correctly.\" With the right method and mindset, adults can learn too.",
      stats: [
        { value: "1997", label: "teaching since" },
        { value: "3", label: "countries" },
        { value: "3,000", label: "learners supported" },
      ],
    },
    marquee: ["METHOD, NOT TALENT", "HABIT BUILDS LANGUAGE", "YOUR PATH", "MULTILINGUAL KIDS", "THE 1-MINUTE METHOD", "USABLE FLUENCY", "AGES 0–8", "ADULTS & KIDS"],
    booking: {
      titleAdults: "Book a free call — Adults",
      titleKids: "Book a consultation — Children (0–8)",
      desc: "Pick a time that works for you from the calendar.",
      notConfigured: "The online booking calendar is being set up. For now, you can book via email using the button below.",
      emailButton: "Book via email",
      close: "Close",
    },
    testimonials: {
      eyebrow: "VOICES",
      title: "From learners & parents",
      note: "* These are sample testimonials — please replace them with real ones.",
      items: [
        {
          quote: "I'd given up thinking I had 'no talent', but the 1-minute method kept me going every day. In three months I could follow English in meetings.",
          name: "M. K.",
          role: "English learner · office worker",
        },
        {
          quote: "I was struggling to raise my 5-year-old multilingually. We built a strategic plan that fit our family, and a two-language environment came naturally.",
          name: "A. T.",
          role: "Parent of a 5-year-old",
        },
        {
          quote: "I nearly gave up during the plateaus, but 'progress isn't linear' saved me. Now I speak without overthinking.",
          name: "R. S.",
          role: "French learner",
        },
      ],
    },
    cta: {
      eyebrow: "LET'S TALK",
      title: "Book a free introductory call",
      body: "For adult learners and for families raising multilingual children alike. Let's start with a relaxed chat.",
      adults: "Book a call for adults",
      kids: "Book a call for children (0–8)",
      adultsSubject: "[My Lingo Map] Free introductory call — Adults",
      kidsSubject: "[My Lingo Map] Consultation for children (0–8)",
      mailBody: "Name:\nPreferred date & time:\nWhat you'd like to discuss:\n",
    },
    footer: {
      tagline: "YOUR PATH TO LEARNING HOW TO LEARN A FOREIGN LANGUAGE",
      rights: "© 2026 My Lingo Map. All rights reserved.",
    },
  },
};
